import React from 'react';
import { CheckCircleOutlined, MinusCircleOutlined } from '@ant-design/icons';
import { Tag } from 'antd';

import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';

import {
  getActiveWans,
  getInstalledApps,
  UbiquitiHostGroup,
} from '../utilities';

import './ubiquitiHostCard.css';

const capitalize = (value: string) =>
  value.length === 0 ? value : value.charAt(0).toUpperCase() + value.slice(1);

type Props = {
  group: UbiquitiHostGroup;
};

// Shared, presentational-only host card — used by the hosts List page and
// as the header of the host details drill-down page. Keep this free of any
// Context/data-fetching so it can be reused wherever a host needs to be
// summarized.
const UbiquitiHostCard = ({ group }: Props) => {
  const isConnected = group.host.reportedState.state === 'connected';

  return (
    <IBCard
      size="small"
      title={
        <div styleName="host-card-title">
          <span>{group.host.reportedState.name}</span>
          <Tag color={group.host.owner ? 'gold' : 'blue'}>
            {group.host.owner ? 'Owner' : 'Invited'}
          </Tag>
        </div>
      }
    >
      <div styleName="host-status-row">
        {isConnected ? (
          <CheckCircleOutlined style={{ color: 'green' }} />
        ) : (
          <MinusCircleOutlined />
        )}
        <span>{group.host.reportedState.hardware.name}</span>
      </div>
      <div styleName="host-ip">{group.host.ipAddress}</div>
      {group.sites !== null &&
        group.sites.map((site) =>
          getActiveWans(site).map((wan) => (
            <div
              key={`${site.siteId}-${wan.externalIp}`}
              styleName="host-isp-row"
            >
              <span>{wan.ispInfo.name}</span>
              <Tag color={wan.wanUptime >= 100 ? 'green' : 'orange'}>
                {wan.wanUptime.toFixed(2)}% uptime
              </Tag>
            </div>
          )),
        )}
      <div styleName="host-apps-row">
        {getInstalledApps(group.host).map((app) => (
          <Tag key={app}>{capitalize(app)}</Tag>
        ))}
      </div>
    </IBCard>
  );
};

export default UbiquitiHostCard;
